var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoGenerateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0492 5.94999V3.82499C11.0492 2.41667 9.90754 1.27499 8.49922 1.27499C7.09089 1.27499 5.94922 2.41667 5.94922 3.82499V5.94999M3.3477 15.725H13.6507C14.5612 15.725 15.2992 15.0007 15.2992 14.1071L14.2432 5.52497C14.2432 4.63146 13.5051 3.90713 12.5947 3.90713H4.1977C3.28727 3.90713 2.54922 4.63146 2.54922 5.52497L1.69922 14.1071C1.69922 15.0007 2.43727 15.725 3.3477 15.725Z",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoGenerateIcon);
export default __webpack_public_path__ + "static/media/POGenerateIcon.35627a719d5413e9524392127b931eeb.svg";
export { ForwardRef as ReactComponent };